import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { LocationAllowedOsUpdateStoreActions as CategoryAllowedOsUpdateStoreActions } from '../location-allowed-os-updates/index';

import { ConcreteCategory, LocationsRouterStoreSelectors } from '../router/index';

@Injectable({ providedIn: 'root' })
export class LocationAllowedOsUpdateResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(LocationsRouterStoreSelectors.selectCategory('Location')).pipe(
      filter((x) => !!x),
      tap((category: ConcreteCategory<'Location'>) => {
        this.store.dispatch(
          CategoryAllowedOsUpdateStoreActions.CategoryAllowedOsUpdatesResolverActions.requested({
            categoryId: category.categoryId,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
